export default {
  'serialRedemption.title': 'シリアルコード交換',
  'serialRedemption.heading': 'シリアルコードを入力してください',
  'serialRedemption.instruction': '入力後、「受け取る」ボタンを押してください',
  'serialRedemption.codeLabel': 'シリアルコード',
  'serialRedemption.codePlaceholder': 'シリアルコードを入力してください',
  'serialRedemption.codeHint': '1〜32文字の英数字を入力してください',
  'serialRedemption.submit': '受け取る',
  'serialRedemption.successReward': '交換に成功しました。「{name}」を受け取りました。',
  'serialRedemption.successPoint':
    '交換に成功しました。{quantity}ポイントが付与されました。',
  'serialRedemption.successGift':
    '交換に成功しました。ギフトパックがクーポン一覧に追加されました。',
  'serialRedemption.goToCouponWallet': 'クーポン一覧へ',
  'serialRedemption.goToPointCard': 'ポイントを見る',
  'serialRedemption.goToPointRecords': 'ポイント履歴へ',
  'serialRedemption.confirm': '確認',
  'serialRedemption.error.SR-001':
    'シリアルコードが存在しません。確認してもう一度入力してください。',
  'serialRedemption.error.SR-002':
    'このコードはすでに受け取られているため、再利用できません',
  'serialRedemption.error.alreadyRedeemedByMember':
    'このコードはすでに交換済みです。特典はアカウントに付与されています',
  'serialRedemption.error.SR-003': 'このコードは期限切れのため受け取れません。',
  'serialRedemption.error.SR-004':
    '現在この特典は交換できません。カスタマーサポートへお問い合わせください。',
  'serialRedemption.error.SR-005':
    'この交換キャンペーンの交換上限に達しました。',
  'serialRedemption.error.SR-006':
    '特典を付与できませんでした。後でもう一度お試しください',
  'serialRedemption.error.SR-007':
    'この特典はまだ開始されていません。キャンペーン開始後に受け取ってください。',
  'serialRedemption.error.SR-008': 'ログインしてから受け取ってください。',
  'serialRedemption.error.SR-010':
    '現在この特典は交換できません。カスタマーサポートへお問い合わせください。',
  'serialRedemption.error.SR-011':
    '現在この特典は交換できません。カスタマーサポートへお問い合わせください。',
  'serialRedemption.error.rateLimited':
    '試行回数が多すぎます。後でもう一度お試しください',
  'serialRedemption.error.unknown':
    'システムが混み合っています。後でもう一度お試しください',
} as Record<string, string>;
